__turbopack_context__.v({
  "grid": "JtZZKa_grid",
  "legend": "JtZZKa_legend",
  "month": "JtZZKa_month",
  "monthNameLong": "JtZZKa_monthNameLong",
  "monthNameShort": "JtZZKa_monthNameShort",
  "value": "JtZZKa_value",
});
